import { AfterViewInit, Component, ElementRef, Injector, ViewChild, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import MapView from '@arcgis/core/views/MapView';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { UtilsService } from '@shared/services/utils.service';
import { MapService } from './services/map.service';
import { MapHeaderComponent } from './components/map-header-component/map-header.component';
import { TranslocoPipe } from '@ngneat/transloco';
import { BasemapGalleryWidgetVisualizationComponent } from './components/basemap-gallery-widget-visualization/basemap-gallery-widget-visualization.component';
import { LayersListWidgetVisualizationComponent } from './components/layers-list-widget-visualization/layers-list-widget-visualization.component';
import { LegendWidgetVisualizationComponent } from './components/legend-widget-visualization/legend-widget-visualization.component';
import { CoreService } from '@core/services';
import { MapResultsFooterComponent } from './components/map-results-footer/map-results-footer.component';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-map',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatCardModule,
            MapHeaderComponent, BasemapGalleryWidgetVisualizationComponent,
            LayersListWidgetVisualizationComponent, TranslocoPipe, LegendWidgetVisualizationComponent,
            MapResultsFooterComponent],
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements AfterViewInit {

  @ViewChild('mapCustomWidgets', { static: true }) private mapCustomWidgetsRef!: ElementRef;
  @ViewChild('locateButton', { read: ElementRef }) private locateButtonRef!: ElementRef;
  @ViewChild('contextMenu', { read: ElementRef }) private contextMenuRef!: ElementRef;
  @ViewChild('resultsDetailContainer', { read: ElementRef }) resultsDetailContainer!: ElementRef;

  private mapService = inject(MapService);
  public showBasemapGallery = this.mapService.showBaseMapGallery;
  public showLayersList = this.mapService.showLayersList;
  public mapLoaded = this.mapService.mapLoaded;
  public mapRotation = this.mapService.mapRotation;
  public waitingForClick = this.mapService.waitingForClick;
  public showingResults = this.mapService.showingResults;

  public isMobile = inject(UtilsService).isMobile;

  public coreService = inject(CoreService);
  public sidenavOpened = this.coreService.sidenavOpened;
  public itinerarySelected = this.coreService.itinerarySelected;
  public routeFormResult = this.coreService.routeFormResult;
  public showItineraryDetails = this.coreService.showItineraryDetails;
  
  public view!: MapView;

  constructor(private injector: Injector, private route: ActivatedRoute){}

  ngAfterViewInit(): void {
    this.mapService.setEsriConfig();
    this.mapService.setContextMenu(this.contextMenuRef);
    this.mapService.createMap();
    const routeParams = this.route.snapshot.queryParams['routeParams'];
    const viewCallback = routeParams ? () => this.coreService.doRequestFromUrlParams(routeParams) : undefined;
    this.view = this.mapService.createView(this.locateButtonRef, viewCallback);

    effect(() => {
      if(!this.itinerarySelected() || !this.resultsDetailContainer) {
        return;
      }
      this.resultsDetailContainer.nativeElement.scrollIntoView({ behavior: 'smooth', top: -40, inline: 'nearest' });
    },{injector: this.injector})
  }

  public toggleSidenav() {
    this.sidenavOpened.set(true);
  }

  public locateButtonClicked() {
    this.mapService.centerToCurrentLocation();
  }

  public routeToHereClicked() {
    if(this.contextMenuRef.nativeElement.latitude && this.contextMenuRef.nativeElement.longitude){
      this.coreService.createRouteToLatitudeLongitude(this.contextMenuRef.nativeElement.latitude, this.contextMenuRef.nativeElement.longitude);
      this.contextMenuRef.nativeElement.style.display = 'none';
    }
  }

  public routeFromHereClicked() {
    if(this.contextMenuRef.nativeElement.latitude && this.contextMenuRef.nativeElement.longitude){
      this.coreService.createRouteFromLatitudeLongitude(this.contextMenuRef.nativeElement.latitude, this.contextMenuRef.nativeElement.longitude);
      this.contextMenuRef.nativeElement.style.display = 'none';
    }
  }

}
